module.exports = __webpack_public_path__ + "img/car-icon-transparent-white.c6a2e234.svg";